export const ORDER_DETAILS_REQUEST = 'ORDER_DETAILS_REQUEST'
export const ORDER_DETAILS_SUCCESS = 'ORDER_DETAILS_SUCCESS'
export const ORDER_DETAILS_SUCCESS_DATA_RECEIVED = 'ORDER_DETAILS_SUCCESS_DATA_RECEIVED'
export const ORDER_DETAILS_SUCCESS_STOP_LOADING = 'ORDER_DETAILS_SUCCESS_STOP_LOADING'
export const ORDER_DETAILS_FAIL = 'ORDER_DETAILS_FAIL'

export const ORDER_LIST_DETAILS_REQUEST = 'ORDER_LIST_DETAILS_REQUEST'
export const ORDER_LIST_DETAILS_SUCCESS = 'ORDER_LIST_DETAILS_SUCCESS'
export const ORDER_LIST_DETAILS_FAIL = 'ORDER_LIST_DETAILS_FAIL'
export const ORDER_LIST_DETAILS_RESET = 'ORDER_LIST_DETAILS_RESET'

export const PRICETYPE_CHANGE_REQUEST = 'PRICETYPE_CHANGE_REQUEST'
export const PRICETYPE_CHANGE_SUCCESS = 'PRICETYPE_CHANGE_SUCCESS'
export const PRICETYPE_CHANGE_FAILURE = 'PRICETYPE_CHANGE_FAILURE'

export const UPDATE_PRICEMARGIN_REQUEST = 'PRICETYPE_CHANGE_REQUEST'
export const UPDATE_PRICEMARGIN_SUCCESS = 'PRICETYPE_CHANGE_SUCCESS'
export const UPDATE_PRICEMARGIN_FAILURE = 'PRICETYPE_CHANGE_FAILURE'

export const UPDATE_LINEPRICE_REQUEST = 'LINEPRICE_CHANGE_REQUEST'
export const UPDATE_LINEPRICE_SUCCESS = 'LINEPRICE_CHANGE_SUCCESS'
export const UPDATE_LINEPRICE_FAILURE = 'LINEPRICE_CHANGE_FAILURE'

export const Lineitemsload_REQUEST = 'Lineitemsload__REQUEST'
export const Lineitemsload_SUCCESS = 'Lineitemsload_SUCCESS'
export const Lineitemsload_FAILURE = 'Lineitemsload_FAILURE'

export const QuoteInputs_REQUEST = 'QuoteInputs__REQUEST'
export const QuoteInputs_SUCCESS = 'QuoteInputs_SUCCESS'
export const QuoteInputs_FAILURE = 'QuoteInputs_FAILURE'

export const ORDER_MORE_DETAILS_REQUEST = 'ORDER_MORE_DETAILS_REQUEST'
export const ORDER_MORE_DETAILS_SUCCESS = 'ORDER_MORE_DETAILS_SUCCESS'
export const ORDER_MORE_DETAILS_FAIL = 'ORDER_MORE_DETAILS_FAIL'

export const ORDER_LIST_TOTAL_DETAILS_REQUEST = 'ORDER_LIST_TOTAL_DETAILS_REQUEST'
export const ORDER_LIST_TOTAL_DETAILS_SUCCESS = 'ORDER_LIST_TOTAL_DETAILS_SUCCESS'
export const ORDER_LIST_TOTAL_DETAILS_FAIL = 'ORDER_LIST_TOTAL_DETAILS_FAIL'

export const EXISTING_ORDER_DETAILS_REQUEST = 'EXISTING_ORDER_DETAILS_REQUEST'
export const EXISTING_ORDER_DETAILS_SUCCESS = 'EXISTING_ORDER_DETAILS_SUCCESS'
export const EXISTING_ORDER_DETAILS_FAIL = 'EXISTING_ORDER_DETAILS_FAIL'

export const ORDER_NUMBERS_REQUEST = 'ORDER_NUMBERS_REQUEST'
export const ORDER_NUMBERS_SUCCESS = 'ORDER_NUMBERS_SUCCESS'
export const ORDER_NUMBERS_FAIL = 'ORDER_NUMBERS_FAIL'

export const UPDATE_QUANTITY_OF_LINE_REQUEST = 'UPDATE_QUANTITY_OF_LINE_REQUEST'
export const UPDATE_QUANTITY_OF_LINE_SUCCESS = 'UPDATE_QUANTITY_OF_LINE_SUCCESS'
export const UPDATE_QUANTITY_OF_LINE_FAIL = 'UPDATE_QUANTITY_OF_LINE_FAIL'

export const UPDATE_PRICE_OF_LINE_REQUEST = 'UPDATE_PRICE_OF_LINE_REQUEST'
export const UPDATE_PRICE_OF_LINE_SUCCESS = 'UPDATE_PRICE_OF_LINE_SUCCESS'
export const UPDATE_PRICE_OF_LINE_FAIL = 'UPDATE_PRICE_OF_LINE_FAIL'

// Generate Quote PDF constants
export const GENERATE_QUOTE_PDF_REQUEST = 'GENERATE_QUOTE_PDF_REQUEST'
export const GENERATE_QUOTE_PDF_SUCCESS = 'GENERATE_QUOTE_PDF_SUCCESS'
export const GENERATE_QUOTE_PDF_FAIL = 'GENERATE_QUOTE_PDF_FAIL'
export const GENERATE_QUOTE_PDF_RESET = 'GENERATE_QUOTE_PDF_RESET'

// Generate Quote constants
export const GENERATE_QUOTE_REQUEST = 'GENERATE_QUOTE_REQUEST'
export const GENERATE_QUOTE_SUCCESS = 'GENERATE_QUOTE_SUCCESS'
export const GENERATE_QUOTE_FAIL = 'GENERATE_QUOTE_FAIL'
export const GENERATE_QUOTE_RESET = 'GENERATE_QUOTE_RESET'

// Create Quotation constants
export const CREATE_QUOTATION_REQUEST = 'CREATE_QUOTATION_REQUEST'
export const CREATE_QUOTATION_SUCCESS = 'CREATE_QUOTATION_SUCCESS'
export const CREATE_QUOTATION_FAIL = 'CREATE_QUOTATION_FAIL'
export const CREATE_QUOTATION_RESET = 'CREATE_QUOTATION_RESET'

// Lock Quote constants
export const LOCK_QUOTE_REQUEST = 'LOCK_QUOTE_REQUEST'
export const LOCK_QUOTE_SUCCESS = 'LOCK_QUOTE_SUCCESS'
export const LOCK_QUOTE_FAIL = 'LOCK_QUOTE_FAIL'

// Update Sales Order constants
export const UPDATE_SALES_ORDER_REQUEST = 'UPDATE_SALES_ORDER_REQUEST'
export const UPDATE_SALES_ORDER_SUCCESS = 'UPDATE_SALES_ORDER_SUCCESS'
export const UPDATE_SALES_ORDER_FAIL = 'UPDATE_SALES_ORDER_FAIL'

// Archive Quote constants
export const ARCHIVE_QUOTE_REQUEST = 'ARCHIVE_QUOTE_REQUEST'
export const ARCHIVE_QUOTE_SUCCESS = 'ARCHIVE_QUOTE_SUCCESS'
export const ARCHIVE_QUOTE_FAIL = 'ARCHIVE_QUOTE_FAIL'

// Bulk Archive Quotes constants
export const BULK_ARCHIVE_QUOTES_REQUEST = 'BULK_ARCHIVE_QUOTES_REQUEST'
export const BULK_ARCHIVE_QUOTES_SUCCESS = 'BULK_ARCHIVE_QUOTES_SUCCESS'
export const BULK_ARCHIVE_QUOTES_FAIL = 'BULK_ARCHIVE_QUOTES_FAIL'

export const UPDATE_PRODUCT_OF_LINE_REQUEST = 'UPDATE_PRODUCT_OF_LINE_REQUEST'
export const UPDATE_PRODUCT_OF_LINE_SUCCESS = 'UPDATE_PRODUCT_OF_LINE_SUCCESS'
export const UPDATE_PRODUCT_OF_LINE_FAIL = 'UPDATE_PRODUCT_OF_LINE_FAIL'

export const UPDATE_MARGIN_OF_LINE_REQUEST = 'UPDATE_MARGIN_OF_LINE_REQUEST'
export const UPDATE_MARGIN_OF_LINE_SUCCESS = 'UPDATE_MARGIN_OF_LINE_SUCCESS'
export const UPDATE_MARGIN_OF_LINE_FAIL = 'UPDATE_MARGIN_OF_LINE_FAIL'

export const UPDATE_SELLING_PRICE_OF_LINE_REQUEST = 'UPDATE_SELLING_PRICE_OF_LINE_REQUEST'
export const UPDATE_SELLING_PRICE_OF_LINE_SUCCESS = 'UPDATE_SELLING_PRICE_OF_LINE_SUCCESS'
export const UPDATE_SELLING_PRICE_OF_LINE_FAIL = 'UPDATE_SELLING_PRICE_OF_LINE_FAIL'

export const SUGGESTION_REQUEST = 'SUGGESTION_REQUEST'
export const SUGGESTION_SUCCESS = 'SUGGESTION_SUCCESS'
export const SUGGESTION_FAIL = 'SUGGESTION_FAIL'

export const RECOMMENDATIONS_REQUEST = 'RECOMMENDATIONS_REQUEST'
export const RECOMMENDATIONS_SUCCESS = 'RECOMMENDATIONS_SUCCESS'
export const RECOMMENDATIONS_FAIL = 'RECOMMENDATIONS_FAIL'
export const RECOMMENDATIONS_RESET = 'RECOMMENDATIONS_RESET'

export const UPDATE_RECOMMENDATIONS_REQUEST = 'UPDATE_RECOMMENDATIONS_REQUEST'
export const UPDATE_RECOMMENDATIONS_SUCCESS = 'UPDATE_RECOMMENDATIONS_SUCCESS'
export const UPDATE_RECOMMENDATIONS_FAIL = 'UPDATE_RECOMMENDATIONS_FAIL'

export const UPDATE_FEEDBACK_OF_LINE_REQUEST = 'UPDATE_FEEDBACK_OF_LINE_REQUEST'
export const UPDATE_FEEDBACK_OF_LINE_SUCCESS = 'UPDATE_FEEDBACK_OF_LINE_SUCCESS'
export const UPDATE_FEEDBACK_OF_LINE_FAIL = 'UPDATE_FEEDBACK_OF_LINE_FAIL'

export const APPROVE_ORDER_REQUEST = 'APPROVE_ORDER_REQUEST'
export const APPROVE_ORDER_SUCCESS = 'APPROVE_ORDER_SUCCESS'
export const APPROVE_ORDER_FAIL = 'APPROVE_ORDER_FAIL'
export const APPROVE_ORDER_RESET = 'APPROVE_ORDER_RESET'

export const APPROVE_ORDER_FEEDBACK_REQUEST = 'APPROVE_ORDER_FEEDBACK_REQUEST'
export const APPROVE_ORDER_FEEDBACK_SUCCESS = 'APPROVE_ORDER_FEEDBACK_SUCCESS'
export const APPROVE_ORDER_FEEDBACK_FAIL = 'APPROVE_ORDER_FEEDBACK_FAIL'

export const DELETE_LINES_REQUEST = 'DELETE_LINES_REQUEST'
export const DELETE_LINES_SUCCESS = 'DELETE_LINES_SUCCESS'
export const DELETE_LINES_FAIL = 'DELETE_LINES_FAIL'

export const DELETE_ORDER_REQUEST = 'DELETE_ORDER_REQUEST'
export const DELETE_ORDER_SUCCESS = 'DELETE_ORDER_SUCCESS'
export const DELETE_ORDER_FAIL = 'DELETE_ORDER_FAIL'

export const ADD_LINE_ITEMS_FROM_UPLOAD_REQUEST = 'ADD_LINE_ITEMS_FROM_UPLOAD_REQUEST'
export const ADD_LINE_ITEMS_FROM_UPLOAD_SUCCESS = 'ADD_LINE_ITEMS_FROM_UPLOAD_SUCCESS'
export const ADD_LINE_ITEMS_FROM_UPLOAD_FAIL = 'ADD_LINE_ITEMS_FROM_UPLOAD_FAIL'

export const SELECTED_ORDER_NUMBER_REQUEST = 'SELECTED_ORDER_NUMBER_REQUEST'
export const SELECTED_ORDER_NUMBER_SUCCESS = 'SELECTED_ORDER_NUMBER_SUCCESS'
export const SELECTED_ORDER_NUMBER_FAIL = 'SELECTED_ORDER_NUMBER_FAIL'

export const UPDATE_SHIP_TO_ADDRESS_REQUEST = 'UPDATE_SHIP_TO_ADDRESS_REQUEST'
export const UPDATE_SHIP_TO_ADDRESS_SUCCESS = 'UPDATE_SHIP_TO_ADDRESS_SUCCESS'
export const UPDATE_SHIP_TO_ADDRESS_RESET = 'UPDATE_SHIP_TO_ADDRESS_RESET'
export const UPDATE_SHIP_TO_ADDRESS_FAIL = 'UPDATE_SHIP_TO_ADDRESS_FAIL'

export const ATTACHMENT_FILES_URL_REQUEST = 'ATTACHMENT_FILES_URL_REQUEST'
export const ATTACHMENT_FILES_URL_SUCCESS = 'ATTACHMENT_FILES_URL_SUCCESS'
export const ATTACHMENT_FILES_URL_FAIL = 'ATTACHMENT_FILES_URL_FAIL'

export const ORDER_NUMBERS_GLOBAL_SEARCH_REQUEST = 'ORDER_NUMBERS_GLOBAL_SEARCH_REQUEST'
export const ORDER_NUMBERS_GLOBAL_SEARCH_SUCCESS = 'ORDER_NUMBERS_GLOBAL_SEARCH_SUCCESS'
export const ORDER_NUMBERS_GLOBAL_SEARCH_FAIL = 'ORDER_NUMBERS_GLOBAL_SEARCH_FAIL'

export const CUSTOMER_DETAILS_LIST_REQUEST = 'CUSTOMER_DETAILS_LIST_REQUEST'
export const CUSTOMER_DETAILS_LIST_SUCCESS = 'CUSTOMER_DETAILS_LIST_SUCCESS'
export const CUSTOMER_DETAILS_LIST_FAIL = 'CUSTOMER_DETAILS_LIST_FAIL'
export const CUSTOMER_DETAILS_LIST_RESET = 'CUSTOMER_DETAILS_LIST_RESET'

export const CREATE_QUOTE_REQUEST = 'CREATE_QUOTE_REQUEST'
export const CREATE_QUOTE_SUCCESS = 'CREATE_QUOTE_SUCCESS'
export const CREATE_QUOTE_FAIL = 'CREATE_QUOTE_FAIL'
export const CREATE_QUOTE_RESET = 'CREATE_QUOTE_RESET'

export const SHOW_DETAILS_REQUEST = 'SHOW_DETAILS_REQUEST'
export const SHOW_DETAILS_SUCCESS = 'SHOW_DETAILS_SUCCESS'
export const SHOW_DETAILS_FAIL = 'SHOW_DETAILS_FAIL'

export const UPDATE_LINE_NUMBER_REQUEST = 'UPDATE_LINE_NUMBER_REQUEST'
export const UPDATE_LINE_NUMBER_SUCCESS = 'UPDATE_LINE_NUMBER_SUCCESS'
export const UPDATE_LINE_NUMBER_FAIL = 'UPDATE_LINE_NUMBER_FAIL'

export const UPDATE_PDFKEYVALUE_REQUEST = 'UPDATE_PDFKEYVALUE_REQUEST'
export const UPDATE_PDFKEYVALUE_SUCCESS = 'UPDATE_PDFKEYVALUE_SUCCESS'
export const UPDATE_PDFKEYVALUE_FAIL = 'UPDATE_PDFKEYVALUE_FAIL'

export const SET_ACRONYMS_REQUEST = 'SET_ACRONYMS_REQUEST'
export const SET_ACRONYMS_FAIL = 'SET_ACRONYMS_FAIL'
export const SET_ACRONYMS_SUCCESS = 'SET_ACRONYMS_SUCCESS'

export const UPDATE_SUPPLIER_REQUEST = 'UPDATE_SUPPLIER_REQUEST'
export const UPDATE_SUPPLIER_SUCCESS = 'UPDATE_SUPPLIER_SUCCESS'
export const UPDATE_SUPPLIER_FAIL = 'UPDATE_SUPPLIER_FAIL'

export const EXPAND_ROW_DETAILS_REQUEST = 'EXPAND_ROW_DETAILS_REQUEST'
export const EXPAND_ROW_DETAILS_SUCCESS = 'EXPAND_ROW_DETAILS_SUCCESS'
export const EXPAND_ROW_DETAILS_FAIL = 'EXPAND_ROW_DETAILS_FAIL'

// new apis starts here
export const UPDATE_QUOTE_NOTES_REQUEST = 'UPDATE_QUOTE_NOTES_REQUEST'
export const UPDATE_QUOTE_NOTES_SUCCESS = 'UPDATE_QUOTE_NOTES_SUCCESS'
export const UPDATE_QUOTE_NOTES_FAIL = 'UPDATE_QUOTE_NOTES_FAIL'

export const LINE_ITEM_REQUEST = 'LINE_ITEM_REQUEST'
export const LINE_ITEM_SUCCESS = 'LINE_ITEM_SUCCESS'
export const LINE_ITEM_FAIL = 'LINE_ITEM_FAIL'

export const PRICE_MARGIN_UPDATE_REQUEST = 'PRICE_MARGIN_UPDATE_REQUEST'
export const PRICE_MARGIN_UPDATE_SUCCESS = 'PRICE_MARGIN_UPDATE_SUCCESS'
export const PRICE_MARGIN_UPDATE_FAIL = 'PRICE_MARGIN_UPDATE_FAIL'

export const QUOTE_LIST_REQUEST = 'QUOTE_LIST_REQUEST'
export const QUOTE_LIST_SUCCESS = 'QUOTE_LIST_SUCCESS'
export const QUOTE_LIST_FAIL = 'QUOTE_LIST_FAIL'
export const QUOTE_LIST_RESET = 'QUOTE_LIST_RESET'

export const TREND_GRAPH_REQUEST = 'TREND_GRAPH_REQUEST'
export const TREND_GRAPH_SUCCESS = 'TREND_GRAPH_SUCCESS'
export const TREND_GRAPH_FAIL = 'TREND_GRAPH_FAIL'

export const GET_QUOTE_LIST_REQUEST = 'GET_QUOTE_LIST_REQUEST'
export const GET_QUOTE_LIST_SUCCESS = 'GET_QUOTE_LIST_SUCCESS'
export const GET_QUOTE_LIST_FAIL = 'GET_QUOTE_LIST_FAIL'
export const GET_QUOTE_LIST_RESET = 'GET_QUOTE_LIST_RESET'

export const GET_AVAILABILITIES_BY_PIDS_REQUEST = 'GET_AVAILABILITIES_BY_PIDS_REQUEST'
export const GET_AVAILABILITIES_BY_PIDS_SUCCESS = 'GET_AVAILABILITIES_BY_PIDS_SUCCESS'
export const GET_AVAILABILITIES_BY_PIDS_FAIL = 'GET_AVAILABILITIES_BY_PIDS_SUCCESS'

/* export const PRICE_MARGIN_CHANGE_INTERNAL_REQUEST = "PRICE_MARGIN_CHANGE_INTERNAL_REQUEST"
export const PRICE_MARGIN_CHANGE_INTERNAL_SUCCESS = "PRICE_MARGIN_CHANGE_INTERNAL_SUCCESS"
export const PRICE_MARGIN_CHANGE_INTERNAL_FAIL = "PRICE_MARGIN_CHANGE_INTERNAL_FAIL" */

export const UPDATE_LINE_ITEM_EXTRAS_REQUEST = 'UPDATE_LINE_ITEM_EXTRAS_REQUEST'
export const UPDATE_LINE_ITEM_EXTRAS_SUCCESS = 'UPDATE_LINE_ITEM_EXTRAS_SUCCESS'
export const UPDATE_LINE_ITEM_NOTES_FAIL = 'UPDATE_LINE_ITEM_NOTES_FAIL'
export const UPDATE_LINE_ITEM_EXTRAS_RESET = 'UPDATE_LINE_ITEM_EXTRAS_RESET'

export const QUOTE_NAV_DATA_REQUEST = 'QUOTE_NAV_DATA_REQUEST'
export const QUOTE_NAV_DATA_SUCCESS = 'QUOTE_NAV_DATA_SUCCESS'
export const QUOTE_NAV_DATA_FAIL = 'QUOTE_NAV_DATA_FAIL'

export const QUICK_ORDER_LINE_ITEMS_REQUEST = 'QUICK_ORDER_LINE_ITEMS_REQUEST'
export const QUICK_ORDER_LINE_ITEMS_SUCCESS = 'QUICK_ORDER_LINE_ITEMS_SUCCESS'
export const QUICK_ORDER_LINE_ITEMS_FAIL = 'QUICK_ORDER_LINE_ITEMS_FAIL'
export const QUICK_ORDER_LINE_ITEMS_RESET = 'QUICK_ORDER_LINE_ITEMS_RESET'

export const RE_SOURCING_REQUEST = 'RE_SOURCING_REQUEST'
export const RE_SOURCING_SUCCESS = 'RE_SOURCING_SUCCESS'
export const RE_SOURCING_FAIL = 'RE_SOURCING_FAIL'
export const RE_SOURCING_RESET = 'RE_SOURCING_RESET'

export const CUSTOMER_SHIPPING_DETAILS_REQUEST = 'CUSTOMER_SHIPPING_DETAILS_REQUEST'
export const CUSTOMER_SHIPPING_DETAILS_SUCCESS = 'CUSTOMER_SHIPPING_DETAILS_SUCCESS'
export const CUSTOMER_SHIPPING_DETAILS_FAIL = 'CUSTOMER_SHIPPING_DETAILS_FAIL'

export const ADMIN_USER_LIST_REQUEST = 'ADMIN_USER_LIST_REQUEST'
export const ADMIN_USER_LIST_SUCCESS = 'ADMIN_USER_LIST_SUCCESS'
export const ADMIN_USER_LIST_FAIL = 'ADMIN_USER_LIST_FAIL'

export const ADMIN_USER_ADD_REQUEST = 'ADMIN_USER_ADD_REQUEST'
export const ADMIN_USER_ADD_SUCCESS = 'ADMIN_USER_ADD_SUCCESS'
export const ADMIN_USER_ADD_FAIL = 'ADMIN_USER_ADD_FAIL'

export const ADMIN_USER_UPDATE_REQUEST = 'ADMIN_USER_UPDATE_REQUEST'
export const ADMIN_USER_UPDATE_SUCCESS = 'ADMIN_USER_UPDATE_SUCCESS'
export const ADMIN_USER_UPDATE_FAIL = 'ADMIN_USER_UPDATE_FAIL'

export const ADMIN_USER_DELETE_REQUEST = 'ADMIN_USER_DELETE_REQUEST'
export const ADMIN_USER_DELETE_SUCCESS = 'ADMIN_USER_DELETE_SUCCESS'
export const ADMIN_USER_DELETE_FAIL = 'ADMIN_USER_DELETE_FAIL'

export const BRANCH_LIST_REQUEST = 'BRANCH_LIST_REQUEST'
export const BRANCH_LIST_SUCCESS = 'BRANCH_LIST_SUCCESS'
export const BRANCH_LIST_FAIL = 'BRANCH_LIST_FAIL'

export const BRANCH_ADD_REQUEST = 'BRANCH_ADD_REQUEST'
export const BRANCH_ADD_SUCCESS = 'BRANCH_ADD_SUCCESS'
export const BRANCH_ADD_FAIL = 'BRANCH_ADD_FAIL'

export const BRANCH_UPDATE_REQUEST = 'BRANCH_UPDATE_REQUEST'
export const BRANCH_UPDATE_SUCCESS = 'BRANCH_UPDATE_SUCCESS'
export const BRANCH_UPDATE_FAIL = 'BRANCH_UPDATE_FAIL'

export const BRANCH_DELETE_REQUEST = 'BRANCH_DELETE_REQUEST'
export const BRANCH_DELETE_SUCCESS = 'BRANCH_DELETE_SUCCESS'
export const BRANCH_DELETE_FAIL = 'BRANCH_DELETE_FAIL'

export const DISTRIBUTOR_LIST_REQUEST = 'DISTRIBUTOR_LIST_REQUEST'
export const DISTRIBUTOR_LIST_SUCCESS = 'DISTRIBUTOR_LIST_SUCCESS'
export const DISTRIBUTOR_LIST_FAIL = 'DISTRIBUTOR_LIST_FAIL'

export const MESSAGE_LIST_REQUEST = 'MESSAGE_LIST_REQUEST'
export const MESSAGE_LIST_SUCCESS = 'MESSAGE_LIST_SUCCESS'
export const MESSAGE_LIST_FAIL = 'MESSAGE_LIST_FAIL'

export const GET_LAST_QUOTED_PRICE_REQUEST = 'GET_LAST_QUOTED_PRICE_REQUEST'
export const GET_LAST_QUOTED_PRICE_SUCCESS = 'GET_LAST_QUOTED_PRICE_SUCCESS'
export const GET_LAST_QUOTED_PRICE_FAIL = 'GET_LAST_QUOTED_PRICE_FAIL'

export const BULK_QUOTE_DELETE_REQUEST = 'BULK_QUOTE_DELETE_REQUEST'
export const BULK_QUOTE_DELETE_SUCCESS = 'BULK_QUOTE_DELETE_SUCCESS'
export const BULK_QUOTE_DELETE_FAIL = 'BULK_QUOTE_DELETE_FAIL'
export const BULK_QUOTE_RESET = 'BULK_QUOTE_RESET'

export const BULK_QUOTE_APPROVE_REQUEST = 'BULK_QUOTE_APPROVE_REQUEST'
export const BULK_QUOTE_APPROVE_SUCCESS = 'BULK_QUOTE_APPROVE_SUCCESS'
export const BULK_QUOTE_APPROVE_FAIL = 'BULK_QUOTE_APPROVE_FAIL'
export const BULK_QUOTE_APPROVE_RESET = 'BULK_QUOTE_APPROVE_RESET'

export const AVAILABILITIES_REQUEST = 'AVAILABILITIES_REQUEST'
export const AVAILABILITIES_SUCCESS = 'AVAILABILITIES_SUCCESS'
export const AVAILABILITIES_FAIL = 'AVAILABILITIES_FAIL'

export const FETCH_ONBOARDING_BRANCHES_REQUEST = 'FETCH_ONBOARDING_BRANCHES_REQUEST'
export const FETCH_ONBOARDING_BRANCHES_SUCCESS = 'FETCH_ONBOARDING_BRANCHES_SUCCESS'
export const FETCH_ONBOARDING_BRANCHES_FAILURE = 'FETCH_ONBOARDING_BRANCHES_FAILURE'

export const SELECT_DISTRIBUTOR_REQUEST = 'SELECT_DISTRIBUTOR_REQUEST'
export const SELECT_DISTRIBUTOR_SUCCESS = 'SELECT_DISTRIBUTOR_SUCCESS'
export const SELECT_DISTRIBUTOR_FAILURE = 'SELECT_DISTRIBUTOR_FAILURE'

export const INSERT_SALESPERSON_REQUEST = 'INSERT_SALESPERSON_REQUEST'
export const INSERT_SALESPERSON_SUCCESS = 'INSERT_SALESPERSON_SUCCESS'
export const INSERT_SALESPERSON_FAILURE = 'INSERT_SALESPERSON_FAILURE'

export const UPDATE_LINE_ITEM_WIRECUT_REQUEST = 'UPDATE_LINE_ITEM_WIRECUT_REQUEST'
export const UPDATE_LINE_ITEM_WIRECUT_SUCCESS = 'UPDATE_LINE_ITEM_WIRECUT_SUCCESS'
export const UPDATE_LINE_ITEM_WIRECUT_FAILURE = 'UPDATE_LINE_ITEM_WIRECUT_FAILURE'

export const UPDATE_UNIT_COST_REQUEST = 'UPDATE_UNIT_COST_REQUEST'
export const UPDATE_UNIT_COST_SUCCESS = 'UPDATE_UNIT_COST_SUCCESS'
export const UPDATE_UNIT_COST_FAILURE = 'UPDATE_UNIT_COST_FAILURE'

export const FETCH_EMAILOG_REQUEST = 'FETCH_EMAILOG_REQUEST'
export const FETCH_EMAILOG_SUCCESS = 'FETCH_EMAILOG_SUCCESS'
export const FETCH_EMAILOG_FAILURE = 'FETCH_EMAILOG_FAILURE'

export const GET_CUSTOMER_PART_NUMBER_BY_PID_REQUEST = 'GET_CUSTOMER_PART_NUMBER_BY_PID_REQUEST'
export const GET_CUSTOMER_PART_NUMBER_BY_PID_SUCCESS = 'GET_CUSTOMER_PART_NUMBER_BY_PID_SUCCESS'
export const GET_CUSTOMER_PART_NUMBER_BY_PID_FAIL = 'GET_CUSTOMER_PART_NUMBER_BY_PID_FAIL'

export const FETCH_CUSTOMER_PART_NUMBERS_REQUEST = 'FETCH_CUSTOMER_PART_NUMBERS_REQUEST'
export const FETCH_CUSTOMER_PART_NUMBERS_SUCCESS = 'FETCH_CUSTOMER_PART_NUMBERS_SUCCESS'
export const FETCH_CUSTOMER_PART_NUMBERS_FAILURE = 'FETCH_CUSTOMER_PART_NUMBERS_FAILURE'

export const UPDATE_CUSTOMER_PART_NUMBER_REQUEST = 'UPDATE_CUSTOMER_PART_NUMBER_REQUEST'
export const UPDATE_CUSTOMER_PART_NUMBER_SUCCESS = 'UPDATE_CUSTOMER_PART_NUMBER_SUCCESS'
export const UPDATE_CUSTOMER_PART_NUMBER_FAILURE = 'UPDATE_CUSTOMER_PART_NUMBER_FAILURE'

export const MARK_FAVORITE_REQUEST = 'MARK_FAVORITE_REQUEST'
export const MARK_FAVORITE_SUCCESS = 'MARK_FAVORITE_SUCCESS'
export const MARK_FAVORITE_FAILURE = 'MARK_FAVORITE_FAILURE'

export const FETCH_FAVORITE_QUOTES_REQUEST = 'FETCH_FAVORITE_QUOTES_REQUEST'
export const FETCH_FAVORITE_QUOTES_SUCCESS = 'FETCH_FAVORITE_QUOTES_SUCCESS'
export const FETCH_FAVORITE_QUOTES_FAILURE = 'FETCH_FAVORITE_QUOTES_FAILURE'

export const GET_PRICE_MARGIN_REQUEST = 'GET_PRICE_MARGIN_REQUEST'
export const GET_PRICE_MARGIN_SUCCESS = 'GET_PRICE_MARGIN_SUCCESS'
export const GET_PRICE_MARGIN_FAIL = 'GET_PRICE_MARGIN_FAIL'

export const PRICE_MARGIN_BATCH_REQUEST = 'PRICE_MARGIN_BATCH_REQUEST'
export const PRICE_MARGIN_BATCH_SUCCESS = 'PRICE_MARGIN_BATCH_SUCCESS'
export const PRICE_MARGIN_BATCH_FAIL = 'PRICE_MARGIN_BATCH_FAIL'

export const GET_SUGGESTION_REQUEST = 'GET_SUGGESTION_REQUEST'
export const GET_SUGGESTION_SUCCESS = 'GET_SUGGESTION_SUCCESS'
export const GET_SUGGESTION_FAIL = 'GET_SUGGESTION_FAIL'
export const GET_SUGGESTION_loadercomplete = 'GET_SUGGESTION_loadercomplete'

export const GET_UPGRADEPRODUCTS_REQUEST = 'GET_UPGRADEPRODUCTS_REQUEST'
export const GET_UPGRADEPRODUCTS_SUCCESS = 'GET_UPGRADEPRODUCTS_SUCCESS'
export const GET_UPGRADEPRODUCTS_FAIL = 'GET_UPGRADEPRODUCTS_FAIL'

// Dashboard Quotes Constants
export const GET_DASHBOARD_QUOTES_REQUEST = 'GET_DASHBOARD_QUOTES_REQUEST'
export const GET_DASHBOARD_QUOTES_SUCCESS = 'GET_DASHBOARD_QUOTES_SUCCESS'
export const GET_DASHBOARD_QUOTES_FAILURE = 'GET_DASHBOARD_QUOTES_FAILURE'

// Transaction Type Update Constants
export const UPDATE_TRANSACTION_TYPE_NEW_REQUEST = 'UPDATE_TRANSACTION_TYPE_NEW_REQUEST'
export const UPDATE_TRANSACTION_TYPE_NEW_SUCCESS = 'UPDATE_TRANSACTION_TYPE_NEW_SUCCESS'
export const UPDATE_TRANSACTION_TYPE_NEW_FAILURE = 'UPDATE_TRANSACTION_TYPE_NEW_FAILURE'

// Email Conversation Constants
export const GET_EMAIL_CONVERSATION_REQUEST = 'GET_EMAIL_CONVERSATION_REQUEST'
export const GET_EMAIL_CONVERSATION_SUCCESS = 'GET_EMAIL_CONVERSATION_SUCCESS'
export const GET_EMAIL_CONVERSATION_FAILURE = 'GET_EMAIL_CONVERSATION_FAILURE'
export const GET_EMAIL_CONVERSATION_CLEAR = 'GET_EMAIL_CONVERSATION_CLEAR'

// Email Conversation List Constants
export const GET_EMAIL_CONVERSATION_LIST_REQUEST = 'GET_EMAIL_CONVERSATION_LIST_REQUEST'
export const GET_EMAIL_CONVERSATION_LIST_SUCCESS = 'GET_EMAIL_CONVERSATION_LIST_SUCCESS'
export const GET_EMAIL_CONVERSATION_LIST_FAILURE = 'GET_EMAIL_CONVERSATION_LIST_FAILURE'
export const CLEAR_EMAIL_CONVERSATIONS = 'CLEAR_EMAIL_CONVERSATIONS'

// Quick Reply Constants
export const SEND_QUICK_REPLY_REQUEST = 'SEND_QUICK_REPLY_REQUEST'
export const SEND_QUICK_REPLY_SUCCESS = 'SEND_QUICK_REPLY_SUCCESS'
export const SEND_QUICK_REPLY_FAILURE = 'SEND_QUICK_REPLY_FAILURE'
export const SEND_QUICK_REPLY_RESET = 'SEND_QUICK_REPLY_RESET'

// Detailed Reply Constants
export const SEND_DETAILED_REPLY_REQUEST = 'SEND_DETAILED_REPLY_REQUEST'
export const SEND_DETAILED_REPLY_SUCCESS = 'SEND_DETAILED_REPLY_SUCCESS'
export const SEND_DETAILED_REPLY_FAILURE = 'SEND_DETAILED_REPLY_FAILURE'
export const SEND_DETAILED_REPLY_RESET = 'SEND_DETAILED_REPLY_RESET'

// Email Signature Constants
export const GET_EMAIL_SIGNATURE_REQUEST = 'GET_EMAIL_SIGNATURE_REQUEST'
export const GET_EMAIL_SIGNATURE_SUCCESS = 'GET_EMAIL_SIGNATURE_SUCCESS'
export const GET_EMAIL_SIGNATURE_FAILURE = 'GET_EMAIL_SIGNATURE_FAILURE'

export const UPDATE_EMAIL_SIGNATURE_REQUEST = 'UPDATE_EMAIL_SIGNATURE_REQUEST'
export const UPDATE_EMAIL_SIGNATURE_SUCCESS = 'UPDATE_EMAIL_SIGNATURE_SUCCESS'
export const UPDATE_EMAIL_SIGNATURE_FAILURE = 'UPDATE_EMAIL_SIGNATURE_FAILURE'

// Email Template Constants
export const GET_EMAIL_TEMPLATE_REQUEST = 'GET_EMAIL_TEMPLATE_REQUEST'
export const GET_EMAIL_TEMPLATE_SUCCESS = 'GET_EMAIL_TEMPLATE_SUCCESS'
export const GET_EMAIL_TEMPLATE_FAILURE = 'GET_EMAIL_TEMPLATE_FAILURE'

export const UPDATE_EMAIL_TEMPLATE_REQUEST = 'UPDATE_EMAIL_TEMPLATE_REQUEST'
export const UPDATE_EMAIL_TEMPLATE_SUCCESS = 'UPDATE_EMAIL_TEMPLATE_SUCCESS'
export const UPDATE_EMAIL_TEMPLATE_FAILURE = 'UPDATE_EMAIL_TEMPLATE_FAILURE'

// Combined Salesperson Signature and Template
export const GET_SALESPERSON_SIGNATURE_TEMPLATE_REQUEST = 'GET_SALESPERSON_SIGNATURE_TEMPLATE_REQUEST'
export const GET_SALESPERSON_SIGNATURE_TEMPLATE_SUCCESS = 'GET_SALESPERSON_SIGNATURE_TEMPLATE_SUCCESS'
export const GET_SALESPERSON_SIGNATURE_TEMPLATE_FAILURE = 'GET_SALESPERSON_SIGNATURE_TEMPLATE_FAILURE'

// Email Suggestions Constants
export const GET_EMAIL_SUGGESTIONS_REQUEST = 'GET_EMAIL_SUGGESTIONS_REQUEST'
export const GET_EMAIL_SUGGESTIONS_SUCCESS = 'GET_EMAIL_SUGGESTIONS_SUCCESS'
export const GET_EMAIL_SUGGESTIONS_FAILURE = 'GET_EMAIL_SUGGESTIONS_FAILURE'

export const PREVIEW_QUOTE_REQUEST = 'PREVIEW_QUOTE_REQUEST'
export const PREVIEW_QUOTE_SUCCESS = 'PREVIEW_QUOTE_SUCCESS'
export const PREVIEW_QUOTE_FAILURE = 'PREVIEW_QUOTE_FAILURE'

export const BULK_UPDATE_MARGIN = 'BULK_UPDATE_MARGIN'
export const BULK_UPDATE_MARGIN_SUCCESS = 'BULK_UPDATE_MARGIN_SUCCESS'
export const BULK_UPDATE_MARGIN_FAILURE = 'BULK_UPDATE_MARGIN_FAILURE'

export const GET_MATCH_STATUS_REQUEST = 'GET_MATCH_STATUS_REQUEST'
export const GET_MATCH_STATUS_SUCCESS = 'GET_MATCH_STATUS_SUCCESS'
export const GET_MATCH_STATUS_FAILURE = 'GET_MATCH_STATUS_FAILURE'

export const LOGIC_APP_STATUS_REQUEST = 'LOGIC_APP_STATUS_REQUEST'
export const LOGIC_APP_STATUS_SUCCESS = 'LOGIC_APP_STATUS_SUCCESS'
export const LOGIC_APP_STATUS_FAIL = 'LOGIC_APP_STATUS_FAIL'

// User Branch Availability Constants
export const UPDATE_USER_BRANCH_AVAILABILITY_REQUEST = 'UPDATE_USER_BRANCH_AVAILABILITY_REQUEST'
export const UPDATE_USER_BRANCH_AVAILABILITY_SUCCESS = 'UPDATE_USER_BRANCH_AVAILABILITY_SUCCESS'
export const UPDATE_USER_BRANCH_AVAILABILITY_FAIL = 'UPDATE_USER_BRANCH_AVAILABILITY_FAIL'

export const CLEAR_USER_BRANCH_AVAILABILITY_REQUEST = 'CLEAR_USER_BRANCH_AVAILABILITY_REQUEST'
export const CLEAR_USER_BRANCH_AVAILABILITY_SUCCESS = 'CLEAR_USER_BRANCH_AVAILABILITY_SUCCESS'
export const CLEAR_USER_BRANCH_AVAILABILITY_FAIL = 'CLEAR_USER_BRANCH_AVAILABILITY_FAIL'

// Send to PunchOut Constants
export const SEND_TO_PUNCHOUT_REQUEST = 'SEND_TO_PUNCHOUT_REQUEST'
export const SEND_TO_PUNCHOUT_SUCCESS = 'SEND_TO_PUNCHOUT_SUCCESS'
export const SEND_TO_PUNCHOUT_FAIL = 'SEND_TO_PUNCHOUT_FAIL'

// Refresh Cost Constants
export const REFRESH_COST_REQUEST = 'REFRESH_COST_REQUEST'
export const REFRESH_COST_SUCCESS = 'REFRESH_COST_SUCCESS'
export const REFRESH_COST_FAIL = 'REFRESH_COST_FAIL'

export const QUICK_CLONE_REQUEST = 'QUICK_CLONE_REQUEST'
export const QUICK_CLONE_SUCCESS = 'QUICK_CLONE_SUCCESS'
export const QUICK_CLONE_FAILURE = 'QUICK_CLONE_FAILURE'

// Highlight Coordinates Constants
export const FETCH_HIGHLIGHT_COORDINATES_REQUEST = 'FETCH_HIGHLIGHT_COORDINATES_REQUEST'
export const FETCH_HIGHLIGHT_COORDINATES_SUCCESS = 'FETCH_HIGHLIGHT_COORDINATES_SUCCESS'
export const FETCH_HIGHLIGHT_COORDINATES_FAILURE = 'FETCH_HIGHLIGHT_COORDINATES_FAILURE'
export const CLEAR_HIGHLIGHT_COORDINATES = 'CLEAR_HIGHLIGHT_COORDINATES'

// Manage All Line Items Constants
export const GET_MANAGE_ALL_LINE_ITEMS_REQUEST = 'GET_MANAGE_ALL_LINE_ITEMS_REQUEST'
export const GET_MANAGE_ALL_LINE_ITEMS_SUCCESS = 'GET_MANAGE_ALL_LINE_ITEMS_SUCCESS'
export const GET_MANAGE_ALL_LINE_ITEMS_FAIL = 'GET_MANAGE_ALL_LINE_ITEMS_FAIL'

// Split Quote Constants
export const SPLIT_QUOTE_REQUEST = 'SPLIT_QUOTE_REQUEST'
export const SPLIT_QUOTE_SUCCESS = 'SPLIT_QUOTE_SUCCESS'
export const SPLIT_QUOTE_FAIL = 'SPLIT_QUOTE_FAIL'
export const SPLIT_QUOTE_RESET = 'SPLIT_QUOTE_RESET'

// Total Order Constants
export const ORDER_TOTAL_REQUEST = 'ORDER_TOTAL_REQUEST'
export const ORDER_TOTAL_SUCCESS = 'ORDER_TOTAL_SUCCESS'
export const ORDER_TOTAL_FAILURE = 'ORDER_TOTAL_FAILURE'

// Multi Branch Availability Constants
export const MULTI_BRANCH_AVAILABILITY_REQUEST = 'MULTI_BRANCH_AVAILABILITY_REQUEST'
export const MULTI_BRANCH_AVAILABILITY_SUCCESS = 'MULTI_BRANCH_AVAILABILITY_SUCCESS'
export const MULTI_BRANCH_AVAILABILITY_FAIL = 'MULTI_BRANCH_AVAILABILITY_FAIL'

export const LINE_ITEM_UPDATE_PENDING = 'LINE_ITEM_UPDATE_PENDING'
export const LINE_ITEM_UPDATE_DONE = 'LINE_ITEM_UPDATE_DONE'

export const UPDATE_PRICE_AFTER_UOM_REQUEST = 'UPDATE_PRICE_AFTER_UOM_REQUEST'
export const UPDATE_PRICE_AFTER_UOM_SUCCESS = 'UPDATE_PRICE_AFTER_UOM_SUCCESS'
export const UPDATE_PRICE_AFTER_UOM_FAIL = 'UPDATE_PRICE_AFTER_UOM_FAIL'
